import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { config } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css";

// Prevent Font Awesome from adding its CSS since we did it manually above:
config.autoAddCss = false;
